var Marionette = require('backbone.marionette');

var ResendConfirmationLinkView = require("./resend-confirmation-link-modal-view");

var CommonUtils = require('../../utils/common-utils.js');
var Radio = require('backbone.radio');

var notificationsChannel = Radio.channel('notifications');

var SessionModel = require('../../models/session-model');

var LoginView = Marionette.View.extend({
    template: require('../../templates/persons/login.html'),

    regions: {
        resendConfirmationLinkFormRegion: '#resend-confirmation-link-form-modal'
    },

    ui: {
        login: '#login',
        password: '#password',
        forgotPasswordLink: '#forgot-password-link',
        needHelpLink: '#need-help-link',
        popup: '#popup',
        resendConfirmationLink: '#resend-confirmation-link',

        name: '#name',
        email: '#email',
        text: '#text',
        send: '#send'
    },

    events: {
        'click #perform-login': 'performLogin',
        'keypress': 'onKeyPress',
        'click @ui.forgotPasswordLink': 'openForgotPasswordModal',
        'click @ui.needHelpLink': 'openNeedHelpModal',
        'click @ui.resendConfirmationLink': 'onClickResendConfirmationLink',

        'click @ui.send': 'send',
        'keyup @ui.name': 'validate',
        'change @ui.name': 'validate',
        'keyup @ui.email': 'validate',
        'change @ui.email': 'validate',
        'keyup @ui.text': 'validate',
        'change @ui.text': 'validate'
    },


    initialize: function () {
        _.bindAll(this, 'performLogin', 'onKeyPress');
        this.utils = new CommonUtils();
        this.session = new SessionModel();
        window.document.title = "Login";
    },

    performLogin: function () {
        var that = this;
        // var redirectUrl = this.utils.getQueryParams()['retpath'] || '/documents?toReview=true&simpleMode=true&object_type=pdf';
        var redirectUrl = that.utils.getQueryParams()['retpath'] || '/documents?object_type=pdf';
        if (that.utils.getQueryParams()['retpath']) {
            redirectUrl = '/' + decodeURIComponent(redirectUrl);
        }
        Backbone.$.ajax({
            type: "POST",
            url: '/api/login/auth?login=' + that.ui.login.val() + '&password=' + that.ui.password.val(),
            data: {},
            dataType: 'application/json',
            statusCode: {
                200: function () {
                    that.session.fetch({
                        success: function (gotSession) {
                            if (gotSession.get('person').initialUrl) {
                                Backbone.history.navigate(gotSession.get('person').initialUrl, {trigger: true});
                            } else {
                                Backbone.history.navigate(redirectUrl, {trigger: true});
                            }
                        }
                    });
                },
                401: function (e) {
                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
                }
            }
        });
    },

    onKeyPress: function (e) {
        if (e.keyCode == 13)
            this.performLogin();
    },

    openForgotPasswordModal: function () {
        this.popupShow("Forgot password");
    },

    openNeedHelpModal: function () {
        this.popupShow("Need help");
    },

    popupShow: function (title) {
        this.$('.modal-title').text(title);
        this.ui.popup.modal('show');
        this.validate();
    },

    validate: function (event) {
        var isAllInputsValid = true;

        if (this.utils.isValidEmail(this.ui.email.val())) {
            this.ui.email.parent().removeClass('has-error has-feedback');
            this.ui.email.tooltip("destroy");
        } else {
            this.ui.email.parent().addClass('has-error has-feedback');
            this.ui.email.tooltip({title: 'Invalid e-mail'});
            this.ui.send.attr("disabled", "true");
            isAllInputsValid = false;
        }

        if (this.ui.name.val().length > 0) {
            this.ui.name.parent().removeClass('has-error has-feedback');
            this.ui.name.tooltip("destroy");
        } else {
            this.ui.name.parent().addClass('has-error has-feedback');
            this.ui.name.tooltip({title: 'Empty name'});
            this.ui.send.attr("disabled", "true");
            isAllInputsValid = false;
        }

        if (this.ui.text.val().length > 0) {
            this.ui.text.parent().removeClass('has-error has-feedback');
            this.ui.text.tooltip("destroy");
        } else {
            this.ui.text.parent().addClass('has-error has-feedback');
            this.ui.text.tooltip({title: 'Empty text'});
            this.ui.send.attr("disabled", "true");
            isAllInputsValid = false;
        }

        if (isAllInputsValid)
            this.ui.send.removeAttr("disabled");
    },

    clearInputs: function () {
        this.ui.name.val('');
        this.ui.email.val('');
        this.ui.text.val('');
    },

    send: function () {
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/help/feedback',
            data: {
                name: that.ui.name.val(),
                email: that.ui.email.val(),
                text: that.ui.text.val()
            },
            dataType: 'text',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    $.notify("Message sent successfully. We will contact you soon.", "success");
                    that.ui.popup.modal('hide');
                    that.clearInputs();
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
            }
        });
    },

    onClickResendConfirmationLink: function () {
        var that = this;
        that.showChildView('resendConfirmationLinkFormRegion', new ResendConfirmationLinkView());
    }
});

module.exports = LoginView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/login-view.js
// module id = 340
// module chunks = 0